import { ActionTypes } from '../constans/action-types';

export const setVendxSessionId = sessionId => ({
  type: ActionTypes.SET_VENDX_SESSION_ID,
  payload: sessionId,
});

export const setTransScriptSession = profile => ({
  type: ActionTypes.SET_TRANSCRIPT_SESSION,
  payload: profile,
});
